/*
  Reasons for shadow:
  - Get custom package data based on zip code submitted by user
*/

import { scrollTo } from '@leshen/ui'
import { navigate } from 'gatsby'
import zipLogic from '../../../../../utils/zipLogic'

const availabilitySubmit = async ({ setIsSubmitted, setUserData, values }) => {
  try {
    // Reset user data to show loading state
    setUserData({
      loading: true,
      businessCenturylinkService: false,
    })

    const isSpanishURL = /^\/es(\/|$)/.test(window.location.pathname)

    // Fetch package data based on zip code
    const packageData = await zipLogic(values.zip_postal, isSpanishURL)

    // Update user data with the fetched package data
    setUserData({
      loading: false,
      businessCenturylinkService: packageData,
    })

    const availabilityPath = '/availability'
    const availabilityPathSlash = '/availability/'

    // Navigate or scroll based on the current path
    if (
      window.location.pathname === availabilityPath ||
      window.location.pathname === availabilityPathSlash
    ) {
      scrollTo('#loadingScrollTarget')
    } else {
      navigate(availabilityPath)
    }

    // Mark submission as complete
    setIsSubmitted(true)
  } catch (error) {
     
    console.error('Error fetching package data:', error)
    setUserData({
      loading: false,
      businessCenturylinkService: false,
    })
    setIsSubmitted(false)
  }
}

export default availabilitySubmit
